import React from "react";
import type { SectionKey } from "../lib/types";

interface NavItemProps {
  label: string;
  section: SectionKey;
  icon: string;
  active: boolean;
  onClick: (section: SectionKey) => void;
}

function NavItem({ label, section, icon, active, onClick }: NavItemProps) {
  return (
    <button
      onClick={() => onClick(section)}
      className={[
        "flex items-center gap-2.5 w-full px-3.5 py-2.5 rounded text-sm text-left transition-all duration-150",
        active
          ? "font-medium text-accent bg-accent-dim"
          : "text-content-secondary bg-transparent hover:bg-bg-hover",
      ].join(" ")}
    >
      <span className="text-base w-5 text-center">{icon}</span>
      {label}
    </button>
  );
}

export default NavItem;